import React, { useState } from "react";
import FormattedDate from "./FormattedDate";
import CurrentTemperature from "./CurrentTemperature";
import Forecast from "./Forecast";
import axios from "axios";

export default function CurrentWeather(props) {
  const [weatherData, setWeatherData] = useState({ loaded: false });
  const [city, setCity] = useState(props.defaultCity);
  function handleResponse(response) {
    setWeatherData({
      loaded: true,
      city: response.data.name,
      coordinates: response.data.coord,
      date: new Date(response.data.dt * 1000),
      temperature: response.data.main.temp,
      feltTemp: response.data.main.feels_like,
      description: response.data.weather[0].description,
      icon: `https://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`,
      wind: response.data.wind.speed,
      humidity: response.data.main.humidity,
    });
  }

  function search() {
    const apiKey = "1a6432c5ca7b6f9b0bee45c98d54ea71";
    let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function handleCityChange(event) {
    setCity(event.target.value);
  }

  if (weatherData.loaded) {
    return (
      <div className="CurrentWeather">
        <div className="row searchbar">
          <div className="col-10">
            <form onSubmit={handleSubmit} className="w-100" id="searchbar">
              <input
                className="w-75"
                type="search"
                id="search-input"
                placeholder="enter city name..."
                onChange={handleCityChange}
              />
              <input className="search-button" type="submit" value="search" />
            </form>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="row">
              <div className="col-12">
                <h3 id="city">{weatherData.city}</h3>
                <ul className="d-d-t">
                  <li id="day">
                    <FormattedDate date={weatherData.date} />
                  </li>
                </ul>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <h3>
                  {" "}
                  <img
                    src={weatherData.icon}
                    alt={weatherData.description}
                    width="80"
                    id="weather-icon"
                  />
                  {weatherData.description}
                </h3>
                <ul className="p-h-w">
                  <li>Humidity: {Math.round(weatherData.humidity)} %</li>
                  <li>
                    Wind:{" "}
                    <span id="wind-speed">
                      {Math.round(weatherData.wind * 3.6)} km/h
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-6 d-flex flex-column justify-content-center align-items-center">
            <CurrentTemperature
              celsius={weatherData.temperature}
              feltCelsius={weatherData.feltTemp}
            />
          </div>
          <Forecast coordinates={weatherData.coordinates} />
        </div>
      </div>
    );
  } else {
    search();
    return "Loading...";
  }
}
